module.exports = __webpack_public_path__ + "img/404.2a4f77d.svg";